<div class="activity-widget" [ngClass]="'activity-widget--' + type">
  <div class="activity-widget__border"></div>
  <div class="activity-widget__count">{{ count }}</div>
  <div class="activity-widget__description">
    {{ 'activity-widget.' + type | translate }}
  </div>
</div>
